export const WS_API_PATH = 'v4/endpoint-desktop/';
